var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex"}},[_c('img',{staticClass:"mr-2",staticStyle:{"height":"32px","width":"auto"},attrs:{"src":require('../assets/icons/' + _vm.image)}}),_c('h1',{staticStyle:{"font-size":"1.5rem","font-weight":"700"}},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }